export default __webpack_public_path__ + "static/media/mpadi.235d0537.jpg";